/** Мок-данные признания расходов для вёрстки, пока нет API */

export const PROJECTS = [
  { id: 1, name: "ОД_505-1_Б_ЗД_МЖК_Capitalpark7BComfort_0_2025_0", organization: "AQMOL-project ТОО" },
  { id: 2, name: "ОД_514-1_Б_ЗД_МЖК_МЖКОIUУчасток6_Цесинстрой_2025", organization: "AQMOL-project ТОО" },
  { id: 3, name: "ОД_320-2_А_ЖК_Riverside_Очередь2_BIGroup_2025", organization: "AQMOL-proBIM ТОО" },
  { id: 4, name: "ОД_118-1_В_БЦ_AlmaTower_Блок1_Базис_2025", organization: "AQMOL-proBIM ТОО" },
  { id: 5, name: "ОД_402-3_Б_ШК_Школа1200_Косшы_2026", organization: "AQMOL-project ТОО" },
];

/** Договоры с подрядчиками: у каждого свой контрагент и статья расходов */
export const CONTRACTS = [
  {
    id: 1,
    projectId: 1,
    name: "№250801 от 01.08.2025г.",
    organization: "AQMOL-project ТОО",
    counterparty: "ТОО ПроектСервис",
    article: "Проектные работы / Субподряд",
    amount: 3000000,
  },
  {
    id: 2,
    projectId: 1,
    name: "№34/05 от 20.05.2025г.",
    organization: "AQMOL-proBIM ТОО",
    counterparty: "Копи Принт Мастер",
    article: "Полиграфические услуги",
    amount: 1200000,
  },
  {
    id: 3,
    projectId: 2,
    name: "№ 260220 от 20.02.2026г.",
    organization: "AQMOL-proBIM ТОО",
    counterparty: "ИП LT Studio",
    article: "Визуализация",
    amount: 2400000,
  },
  {
    id: 4,
    projectId: 2,
    name: "№251015 от 15.10.2025г.",
    organization: "AQMOL-project ТОО",
    counterparty: "Айкоркем Ж.С. ИП",
    article: "Проектные работы / Субподряд",
    amount: 4500000,
  },
  {
    id: 5,
    projectId: 3,
    name: "№117/25 от 03.11.2025г.",
    organization: "AQMOL-proBIM ТОО",
    counterparty: "ТОО ГеоИзыскания",
    article: "Инженерные изыскания",
    amount: 6800000,
  },
  {
    id: 6,
    projectId: 4,
    name: "№260112 от 12.01.2026г.",
    organization: "AQMOL-proBIM ТОО",
    counterparty: "ТОО ПроектСервис",
    article: "Проектные работы / Субподряд",
    amount: 5000000,
  },
  {
    id: 7,
    projectId: 5,
    name: "№260305 от 05.03.2026г.",
    organization: "AQMOL-project ТОО",
    counterparty: "Айкоркем Ж.С. ИП",
    article: "Проектные работы / Субподряд",
    amount: 3600000,
  },
  {
    id: 8,
    projectId: 3,
    name: "№260401 от 01.04.2026г.",
    organization: "AQMOL-proBIM ТОО",
    counterparty: "Копи Принт Мастер",
    article: "Полиграфические услуги",
    amount: 900000,
  },
];

export const ARTICLES = [
  "Проектные работы / Субподряд",
  "Инженерные изыскания",
  "Визуализация",
  "Полиграфические услуги",
];

const unique = (values) => [...new Set(values)].sort((a, b) => a.localeCompare(b, "ru"));

export const ORGANIZATIONS = unique(PROJECTS.map((project) => project.organization));
export const COUNTERPARTIES = unique(CONTRACTS.map((contract) => contract.counterparty));

export const PROJECT_BY_ID = Object.fromEntries(PROJECTS.map((project) => [project.id, project]));
export const CONTRACT_BY_ID = Object.fromEntries(CONTRACTS.map((contract) => [contract.id, contract]));

const PERIODS = {
  1: ["01.01.2026", "31.12.2026"],
  2: ["01.02.2026", "30.09.2026"],
  3: ["01.03.2026", "31.12.2026"],
  4: ["01.01.2026", "31.10.2026"],
  5: ["01.01.2026", "30.06.2026"],
  6: ["01.02.2026", "31.01.2027"],
  7: ["01.04.2026", "31.03.2027"],
};

/** Периоды признания по договорам; договор 8 намеренно не настроен */
export const INITIAL_CONTRACT_SETTINGS = Object.entries(PERIODS).map(
  ([contractId, [startDate, endDate]], index) => {
    const contract = CONTRACT_BY_ID[contractId];
    return {
      id: index + 1,
      contractId: contract.id,
      organization: contract.organization,
      counterparty: contract.counterparty,
      startDate,
      endDate,
    };
  }
);

const MONTH_ENDS_2026 = [
  "31.01.2026",
  "28.02.2026",
  "31.03.2026",
  "30.04.2026",
  "31.05.2026",
  "30.06.2026",
  "31.07.2026",
  "31.08.2026",
];

const READINESS_PLAN = [
  { contractId: 1, fromMonth: 0, readiness: [10, 25, 52, 85] },
  { contractId: 2, fromMonth: 1, readiness: [20, 45, 70, 90, 100] },
  { contractId: 3, fromMonth: 2, readiness: [15, 30, 50, 65, 80, 95] },
  { contractId: 4, fromMonth: 0, readiness: [8, 16, 25, 34, 42, 50, 60, 68] },
  { contractId: 5, fromMonth: 0, readiness: [12, 30, 48, 66, 84, 100] },
  { contractId: 6, fromMonth: 1, readiness: [6, 14, 22, 31, 40, 48, 55] },
  { contractId: 7, fromMonth: 3, readiness: [10, 20, 35, 45, 60] },
];

const buildRecognitions = () => {
  const result = [];
  READINESS_PLAN.forEach(({ contractId, fromMonth, readiness }) => {
    const contract = CONTRACT_BY_ID[contractId];
    let previous = 0;
    readiness.forEach((percent, index) => {
      const cumulative = Math.round((contract.amount * percent) / 100);
      result.push({
        date: MONTH_ENDS_2026[fromMonth + index],
        projectId: contract.projectId,
        organization: contract.organization,
        counterparty: contract.counterparty,
        contractId,
        article: contract.article,
        contractAmount: contract.amount,
        readiness: percent,
        cumulative,
        previous,
        current: cumulative - previous,
      });
      previous = cumulative;
    });
  });
  return result.map((item, index) => ({
    ...item,
    id: index + 1,
    document: `ПР-${String(index + 101).padStart(6, "0")}`,
  }));
};

export const INITIAL_RECOGNITIONS = buildRecognitions();

/** Справочники в формате, который ожидает общая страница признания */
export const EXPENSE_DATA = {
  projects: PROJECTS,
  contracts: CONTRACTS,
  articles: ARTICLES,
  organizations: ORGANIZATIONS,
  counterparties: COUNTERPARTIES,
  projectById: PROJECT_BY_ID,
  contractById: CONTRACT_BY_ID,
};
